/* tslint:disable:no-console */
import { Component, Mixins } from 'vue-property-decorator';
import CommonMixin from '@/mixins/CommonMixin';
import OverviewLayout from '@/components/OverviewLayout.vue';
import FileUpload from '@/components/FileUpload.vue';
import { OverviewLayoutITF } from '@/interfaces';

@Component({
  components: {
    OverviewLayout,
    FileUpload
  }
})
export default class OverviewMixin extends Mixins(CommonMixin) {
  public filters = {};

  public countSelections() {
    if (this.$refs.overview) {
      return ((this.$refs
        .overview as unknown) as OverviewLayoutITF).countSelections();
    } else {
      return 0;
    }
  }

  public getSelectedIds() {
    if (this.$refs.overview) {
      return ((this.$refs.overview as unknown) as OverviewLayoutITF).getSelectedIds();
    } else {
      return [];
    }
  }

  public filteredOverview() {
    if (this.$refs.overview) {
      return ((this.$refs
        .overview as unknown) as OverviewLayoutITF).filteredOverview();
    } else {
      return 0;
    }
  }

  public getFilterValues() {
    if (this.$refs.overview) {
      const filters: object = {};
      ((this.$refs.overview as unknown) as OverviewLayoutITF).getFilterValues(
        filters
      );
      return filters;
    } else {
      return {};
    }
  }

  public getSortString() {
    if (this.$refs.overview) {
      return ((this.$refs
        .overview as unknown) as OverviewLayoutITF).getSortString();
    } else {
      return '';
    }
  }
}
